import Tracker from './Tracker.js'

export const trace = function(eventId, obj) {
    Tracker.send({
        data: {
            type: eventId,
            data: obj || {}
        }
    });
};

export const enterTrace = function(obj) {
    Tracker.send({
        data: {
            type: 'ins_in',
            data: obj || {}
        }
    });
};

export const enterTraceDone = function(obj) {
    Tracker.send({
        data: {
            type: 'ins_done',
            data: obj || {}
        }
    });
};


// WEBPACK FOOTER //
// ./src/lib/Utils/trace.js